import React, { Dispatch, SetStateAction } from 'react';
import TableComponent from 'app/components/TableComponent';
import { Link } from 'react-router-dom';

type Props = {
  data: {
    month: string;
    period: string;
    yearPeriod: number;
    primeraNomina: number;
    complemento: number;
    total: number;
    statusPeriod: number;
  }[];
  totalRecords: number;
  pageSize: number;
  currentPage: number;
  setCurrentPage: Dispatch<SetStateAction<number>>;
};

const heads = [
  { code: 'month', label: 'Mes' },
  { code: 'period', label: 'Periodo' },
  { code: 'yearPeriod', label: 'Año' },
  { code: 'primeraNomina', label: 'Primera Nómina' },
  { code: 'complemento', label: 'Complemento' },
  { code: 'total', label: 'Total' },
  { code: 'statusPeriod', label: 'Estado' },
];

const TableList: React.FC<Props> = ({ data, totalRecords, pageSize, currentPage, setCurrentPage }) => {
  const renderEstado = (estado: number) => {
    if (estado === 1) {
      return (
        <Link className="text-info" style={{ color: 'blue', cursor: 'pointer' }} to="nomina/detalle">
          EN TRAMITE
        </Link>
      );
    }
    return (
      <Link className="text-error" style={{ cursor: "default" }} to="#">
        FINALIZADO
      </Link>
    );
  };

  const processedRows = data.map((item) => ({
    ...item,
    statusPeriod: renderEstado(item.statusPeriod),
  }));

  return (
    <div className="row gy-5 g-xl-8">
      <div className="col-xxl-12 col-xl-12 col-md-12 col-lg-12">
        <div className="card card-flush p-5">
          <h3 className="fw-bold fs-4 mb-5">Tabla de Nóminas</h3>
          <div className="tablee-container">
          <TableComponent
            heads={heads} rows={processedRows}
            rowsPerPage={pageSize}
            page={currentPage}
            totalRows={totalRecords}
            setPage={setCurrentPage}
          />
          </div>
        </div>
      </div>
    </div>
  );
};

export { TableList };
